export function getAnonymousUser() {
    return {
        isAnonymousUser: true,
        isBathroomOnlineUser: false,
        isMaxUser: false,
        isUnlinkedTradeUser: false
    };
}